import Box from '@mui/material/Box'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import { CSSProperties, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import KanseiBreadcrumbs from 'components/breadcrumb'
import { companyApi } from 'hooks/api/company'
import { Company } from 'types/company'

export default function BranchPage() {
  const [company, setCompany] = useState<Company>()
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()

  const fetchData = () => {
    companyApi()
      .findById(id!)
      .then((res) => {
        setCompany(res.data)
      })
  }

  useEffect(() => {
    fetchData()
  }, [])

  const links = [
    {
      title: '警備会社一覧',
      to: '/cls1/company',
    },
    {
      title: company ? company.name : '',
    },
  ]

  const handleToDetail = (branchId: string) => () => {
    navigate(`/cls1/company/${id}/branch/${branchId}`)
  }

  return (
    <Box>
      <KanseiBreadcrumbs links={links} style={{ marginBottom: '15px' }} />
      <List>
        {company?.companyBranches?.map((branch) => (
          <>
            {branch.id && (
              <ListItemButton
                key={branch.id}
                onClick={handleToDetail(branch.id)}
                style={listItemStyle}
              >
                {branch.branchName}
              </ListItemButton>
            )}
          </>
        ))}
      </List>
    </Box>
  )
}

const listItemStyle: CSSProperties = {
  borderBottom: '1px solid #ccc',
}
